import { render, staticRenderFns } from "./liberacaoAutomatica.vue?vue&type=template&id=93555ea4&scoped=true&"
import script from "./liberacaoAutomatica.vue?vue&type=script&lang=js&"
export * from "./liberacaoAutomatica.vue?vue&type=script&lang=js&"
import style0 from "./liberacaoAutomatica.vue?vue&type=style&index=0&id=93555ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93555ea4",
  null
  
)

export default component.exports